/**
 * Runtime + build-time configuration.
 *
 * Resolution order for the API base URL:
 *   1. window.__MEMOS_CONFIG__.apiBaseUrl  (runtime, injected by hosting layer)
 *   2. import.meta.env.VITE_API_BASE_URL   (build time)
 *   3. ""                                   (same origin — the default)
 *
 * Same-origin is the required default for private instances (PRD §6.2): the
 * reverse proxy forwards /api/*, /file/*, /healthz, RSS and /mcp to the backend.
 */
export function getApiBaseUrl(): string {
  const runtime = window.__MEMOS_CONFIG__?.apiBaseUrl;
  if (typeof runtime === "string" && runtime.length > 0) return runtime.replace(/\/$/, "");
  const buildTime = import.meta.env.VITE_API_BASE_URL;
  if (typeof buildTime === "string" && buildTime.length > 0) return buildTime.replace(/\/$/, "");
  return "";
}

export const API_BASE_URL = getApiBaseUrl();

/** Build an absolute URL against the configured backend base. */
export function apiUrl(path: string): string {
  if (!path.startsWith("/")) path = `/${path}`;
  return `${API_BASE_URL}${path}`;
}
